import React from 'react';
import PropTypes from 'prop-types';
import omit from 'lodash/fp/omit';
import withStyles from 'isomorphic-style-loader/withStyles';
import { LANGUAGES } from 'config/types/prop';
import I18n from 'components/i18n';
import EditionPickerDropdown from './dropdown';

import styles from './editionPicker.css';

const EditionPicker = ({
  editions,
  currentEdition,
}) => {
  const filteredEditions = omit([currentEdition], editions);

  if (editions[currentEdition]) {
    return (
      <div className={styles.wrapper}>
        <div className={styles.heading}>
          <I18n
            field="babbel-magazine-edition"
            defaultText="Babbel Magazine Edition"
          />
        </div>
        <EditionPickerDropdown
          selectedEdition={editions[currentEdition].name}
          editions={filteredEditions}
        />
      </div>
    );
  }

  return false;
};

EditionPicker.propTypes = {
  currentEdition: LANGUAGES.isRequired,
  editions: PropTypes.object.isRequired,
};

const wrapWithStyles = withStyles(styles);

export default wrapWithStyles(EditionPicker);
